const events = {
  NFAtoDFA: "NFAtoDFA Event",
  GRtoPDA: "GRtoPDA Event",
  FSAtoRE: "FSAtoRE Event",
  REtoNFA: "REtoNFA Event",
  PDAtoGR: "PDAtoGR Event",
};
export default events;
